// extracted by mini-css-extract-plugin
export default {"card":"SingleComponent_card__1CaKB","rating":"SingleComponent_rating__I1XYS","title":"SingleComponent_title__WeArr"};